import 'twin.macro';
import {
  getProgrammationIllusration,
  getProgressionIllustration,
} from 'containers/Programmations/assets';
import React, { Suspense } from 'react';
import SimpleNarrowPage from '@teetsh/app/src/components/Layouts/SimpleNarrowPage';
import Card from '@teetsh/app/src/components/Card';
import { useSchoolGoTo } from '@teetsh/app/src/containers/App/useSchoolGoTo';
import { useTranslation } from 'react-i18next';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

interface NewOptionCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  onClick: () => void;
}

function NewOptionCard(props: NewOptionCardProps) {
  const { title, description, icon, onClick } = props;
  return (
    <Card
      tw="p-4! lg:pt-8! grid items-center justify-center grid-cols-5 lg:grid-cols-1 lg:grid-rows-3 gap-4 lg:gap-x-0 rounded-lg! border-transparent! hover:border-neutral-moderate!"
      interactive
      onClick={onClick}
    >
      <div tw="col-span-3">
        <h2 tw="mb-1 lg:mb-2.5 text-xl md:text-2xl">{title}</h2>
        <div tw="text-neutral-quiet text-sm lg:text-base">{description}</div>
      </div>
      <div tw="col-span-2 lg:row-span-2 inline-flex justify-center items-center [&_svg]:h-auto">
        {icon}
      </div>
    </Card>
  );
}

export function ProgrammationOrProgression() {
  const goTo = useSchoolGoTo();
  const { t } = useTranslation(['programmation', 'common']);
  return (
    <div>
      <div tw="mb-6 pt-2 pb-4 w-full inline-flex items-center justify-between">
        <Button
          onClick={() => goTo('programmations')}
          minimal
          intent="none"
          icon={ArrowLeftIcon}
          aria-label="Retour"
        />
        <h1 tw="pr-9 grow text-center lg:display">
          {t('programmation:onboarding.step1Title')}
        </h1>
      </div>
      <SimpleNarrowPage width="5xl" tw="px-0!">
        <div tw="mb-6 text-center text-balance grid justify-center gap-4 grid-cols-1 lg:grid-cols-2">
          <NewOptionCard
            title={t('programmation:onboarding.progressionTitle')}
            description={t('programmation:onboarding.progressionDescription')}
            icon={
              <Suspense>
                {getProgressionIllustration(t('common:locale.short'))}
              </Suspense>
            }
            onClick={async () => {
              goTo('programmations/new/progression');
            }}
          />
          <NewOptionCard
            title={t('programmation:onboarding.programmationTitle')}
            description={t('programmation:onboarding.programmationDescription')}
            icon={
              <Suspense>
                {getProgrammationIllusration(t('common:locale.short'))}
              </Suspense>
            }
            onClick={async () => {
              goTo('programmations/new/programmation');
            }}
          />
        </div>
      </SimpleNarrowPage>
    </div>
  );
}
